import { IAppConfiguration } from "../cemexng2components/components/app-configuration";

export default [
  {
    feature: "dashboard.special-invoices",
    country: ["MX"],
  },
  {
    feature: "dashboard.pending-orders",
    country: ["FR", "IL", "EG"],
  },
  {
    feature: "dashboard.credit-limit",
    country: ["CO"],
    role_any: ["CAORGAPC", "CAORGARCADV", "ARMORGAPC", "ARMORGARCADV"],
    options: {
      companyCodes: ["7544"],
    },
  },
  {
    feature: "dashboard.credit-limit",
    country: ["EG"],
    options: {
      companyCodes: ["4520"],
    },
  },
  {
    feature: "dashboard.balance",
    country: ["CO"],
    role_any: ["CAORGAPC", "CAORGARCADV", "ARMORGAPC", "ARMORGARCADV"],
    options: {
      companyCodes: ["7544"],
      normalBalanceCard: true,
    },
  },
  {
    feature: "dashboard.balance",
    country: ["EG"],
    options: {
      companyCodes: ["4520"],
    },
  },
  {
    feature: "dashboard.credit-limit",
    country: ["MX", "PA", "CR", "NI", "SV", "US", "CO", "DE", "GT", "DO", "PR", "PE", "AE", "CZ", "PH"],
  },
  {
    feature: "dashboard.credit-limit-pending-orders",
    country: ["MX", "PA", "CR", "NI", "SV", "US", "DE", "GT", "PR", "PE", "AE", "CZ", "PH"],
    excludes: { country: ["PH"] },
  },
  {
    feature: "dashboard.credit-line",
    country: ["PL"],
  },
  {
    feature: "dashboard.balance-note",
    country: ["ES"],
  },
  {
    feature: "dashboard.account-statement-report",
    country: ["US"],
  },
  {
    feature: "dashboard.alternative-payments",
    country: ["US"],
    role_any: ["ARMORGAPC","ARMSTAFFAPC"],
    options: { applicationCodes: [""] },
  },
  {
    feature: "dashboard.payments",
    country: ["CO"],
    role_any: ["ARMORGARCADV", "CAORGARCAdv", "CAORGARCADV","ARMSTAFFDM"],
    options: { applicationCodes: ["Construagil_App"] },
  },
  {
    feature: "dashboard.payments",
    country: ["PH", "GB", "DO"],
    role_any: ["ARMORGARCADV"],
    options: { applicationCodes: [""] },
  },
  {
    feature: "dashboard.payments",
    country: ["MX"],
    role_any: ["ARMSTAFFRECONCILE", "ARMORGRECONCILE", "ARMORGARCADV"],
    options: { applicationCodes: [""] },
  },
  {
    feature: "dashboard.payments-reconcile",
    country: ["MX"],
    role_any: ["ARMSTAFFRECONCILE", "ARMORGRECONCILE"],
  },
  {
    feature: "dashboard.payments-bulk-payment",
    country: ["MX", "US"],
    role_any: ["ARMORGAPC", "ARMORGARCADV","ARMSTAFFAPC"],
  },
  {
    feature: "dashboard.payments-bulk-payment",
    country: ["CO"],
    role_any: ["ARMORGAPC", "ARMORGARCADV"],
    environment: "Development",
  },
  {
    feature: "dashboard.reference-payments",
    country: ["MX", "AE", "CO", "GB", "DO"],
  },
  {
    feature: "dashboard.reference-payments",
    country: ["PH"],
    environment: ["Development", "Quality"],
  },
  {
    feature: "dashboard.reference-payments",
    country: ["US"]
  },
  {
    feature: "dashboard.reference-payments-reconcile",
    country: ["PH"],
    role_any: ["ARMORGRECONCILE"],
  },
  {
    feature: "dashboard.general-estatus",
    country: ["ES", "LV"],
  },
  {
    feature: "dashboard.enabled-balance-group",
    country: ["PL"],
  },
  {
    feature: "dashboard.balance",
    country: ["PL"],
  },
  {
    feature: "dashboard.disclaimer",
    country: ["ES", "LV"],
    options: {
      header: "views.disclaimer.disclaimer_header",
      body: "views.disclaimer.disclaimer_body",
    },
  },
  {
    feature: "dashboard.white-disclaimer",
    country: ["IL"],
    options: {
      header: "views.disclaimer.disclaimer_header_IL",
      body: "views.disclaimer.disclaimer_body_IL",
    },
  },
  {
    feature: "dashboard.disclaimer",
    country: ["PL"],
    options: {
      body: "views.dashboard.disclaimer-body",
    },
  },
  {
    feature: "dashboard.history-payments",
    country: ["CO", "GB", "DO"],
  },
  {
    feature: "dashboard.history-payments",
    country: ["PH"],
    environment: ["Development", "Quality"],
  },
  {
    feature: "dashboard.history-payments",
    country: ["US"]
  },
  {
    feature: "dashboard.request-credit-line-downloadPdf-onDemand",
    country: ["MX"],
  },
  {
    feature: "dashboard.request-credit-line-create-unrestricted",
    country: ["MX"],
  },
  {
    feature: "dashboard.request-credit-line",
    country: ["MX", "US", "CO"],
    role_any: ["ARMORGREQUESTCREDIT"],
  },
  {
    feature: "dashboard.request-credit-line-console",
    country: ["MX", "US", "CO"],
    role_any: ["ARMORGREQUESTCREDIT", "ARMSTAFFREQUESTCREDIT"],
  },
  {
    feature: "dashboard.request-credit-line-console",
    country: ["MX", "US", "CO"],
    role_any: ["ARMORGREQUESTCREDIT", "ARMSTAFFREQUESTCREDIT"],
    environment: ["Development", "Quality"],
  },
  {
    feature: "dashboard.pagosenlinea-enabled",
    country: ["CO"],
    options: {
      dominio: "pagosenlineaco",
      companies: ["7441", "7443"]
    }
  },
  {
    feature: "dashboard.pagosenlinea-enabled",
    country: ["CO"],
    options: {
      dominio: "localhost",
      companies: ["3032", "7460"]
    }
  }
] as IAppConfiguration[];
